module.exports = __webpack_public_path__ + "distribution/img/arr-rig.9996c920.svg";